module.exports = __webpack_public_path__ + "img/certyfikowane-uzywane.a6404cfa.webp";